function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@okee-uikit/react-hooks';
import { shallowEqual, clamp } from '@okee-uikit/react-utils';
export var LeafColumnManager = function (_Emitter) {
  _inherits(LeafColumnManager, _Emitter);

  var _super = _createSuper(LeafColumnManager);

  function LeafColumnManager() {
    var _this;

    _classCallCheck(this, LeafColumnManager);

    _this = _super.apply(this, arguments);
    _this.width = 0;
    _this.map = {};
    _this.fixedLeftColumns = [];
    _this.nonFixedColumns = [];
    _this.fixedRightColumns = [];
    _this.minimalNonFixedWidth = 0;
    _this.nonFixedScroll = 0;
    return _this;
  }

  _createClass(LeafColumnManager, [{
    key: "updateOptions",
    value: function updateOptions(options) {
      var _options$minimalNonFi = options.minimalNonFixedWidth,
          minimalNonFixedWidth = _options$minimalNonFi === void 0 ? 0 : _options$minimalNonFi,
          columns = options.columns;
      this.minimalNonFixedWidth = minimalNonFixedWidth;
      this.updateColumns(columns);
      this.emit('size', this.getColumnSizeInfo());
    }
  }, {
    key: "getHeadDeep",
    value: function getHeadDeep() {
      var leaf = this;
      return Math.max.apply(Math, _toConsumableArray(leaf.getShownColumns().map(function (key) {
        return leaf.getColumn(key).getLevel();
      })));
    }
  }, {
    key: "getColumnSizeInfo",
    value: function getColumnSizeInfo() {
      var leaf = this;
      return {
        tableWidth: leaf.getTableWidth(),
        fixedLeftWidth: leaf.ignoreFixedLeft() ? 0 : leaf.getFixedLeftWidth(),
        visibleWidth: leaf.getVisibleWidth(),
        scrollerWidth: leaf.getScrollerWidth(),
        fixedRightWidth: leaf.ignoreFixedRight() ? 0 : leaf.getFixedRightWidth(),
        ignoreFixedLeft: leaf.ignoreFixedLeft(),
        ignoreFixedRight: leaf.ignoreFixedRight()
      };
    }
  }, {
    key: "getColumnScrollInfo",
    value: function getColumnScrollInfo() {
      var leaf = this;
      return {
        scroll: this.nonFixedScroll,
        isFixedLeftCover: leaf.isFixedLeftCover(),
        isFixedRightCover: leaf.isFixedRightCover()
      };
    }
  }, {
    key: "isFirstShowColumn",
    value: function isFirstShowColumn(key) {
      var first = this.getShownColumns().shift();

      if (first == null) {
        return false;
      }

      var map = {};
      var column = this.getColumn(first);

      while (column != null) {
        map[column.getKey()] = true;
        column = column.getParent();
      }

      return map[key];
    }
  }, {
    key: "isLastShownColumn",
    value: function isLastShownColumn(key) {
      var first = this.getShownColumns().pop();

      if (first == null) {
        return false;
      }

      var map = {};
      var column = this.getColumn(first);

      while (column != null) {
        map[column.getKey()] = true;
        column = column.getParent();
      }

      return map[key];
    }
  }, {
    key: "updateTableWidth",
    value: function updateTableWidth(width) {
      if (width !== this.width) {
        this.width = width;
        this.updateColumnSize();
        this.emit('size', this.getColumnSizeInfo());
        this.emit('scroll', this.getColumnScrollInfo());
      }
    }
  }, {
    key: "getTableWidth",
    value: function getTableWidth() {
      return this.width;
    }
  }, {
    key: "getNonFixedScroll",
    value: function getNonFixedScroll() {
      return this.nonFixedScroll;
    }
  }, {
    key: "updateNonFixedScroll",
    value: function updateNonFixedScroll(scroll) {
      var max = this.getScrollerWidth() - this.getVisibleWidth();
      scroll = clamp(Math.abs(scroll), 0, max) * Math.sign(scroll);

      if (scroll !== this.nonFixedScroll) {
        this.nonFixedScroll = scroll;
        this.emit('scroll', this.getColumnScrollInfo());
      }
    }
  }, {
    key: "getVisibleWidth",
    value: function getVisibleWidth() {
      return this.getTableWidth() - (this.ignoreFixedLeft() ? 0 : this.getFixedLeftWidth()) - (this.ignoreFixedRight() ? 0 : this.getFixedRightWidth());
    }
  }, {
    key: "getScrollerWidth",
    value: function getScrollerWidth() {
      return this.getNonFixedWidth() + (this.ignoreFixedLeft() ? this.getFixedLeftWidth() : 0) + (this.ignoreFixedRight() ? this.getFixedRightWidth() : 0);
    }
  }, {
    key: "getFixedLeftColumns",
    value: function getFixedLeftColumns() {
      return this.fixedLeftColumns;
    }
  }, {
    key: "getNonFixedColumns",
    value: function getNonFixedColumns() {
      return this.nonFixedColumns;
    }
  }, {
    key: "getFixedRightColumns",
    value: function getFixedRightColumns() {
      return this.fixedRightColumns;
    }
  }, {
    key: "getShownColumns",
    value: function getShownColumns() {
      return [].concat(_toConsumableArray(this.fixedLeftColumns), _toConsumableArray(this.nonFixedColumns), _toConsumableArray(this.fixedRightColumns));
    }
  }, {
    key: "getColumn",
    value: function getColumn(key) {
      return this.map[key];
    }
  }, {
    key: "getFixedLeftWidth",
    value: function getFixedLeftWidth() {
      var _this2 = this;

      return this.fixedLeftColumns.reduce(function (sum, item) {
        return sum + _this2.getColumn(item).getWidth();
      }, 0);
    }
  }, {
    key: "getNonFixedWidth",
    value: function getNonFixedWidth() {
      var _this3 = this;

      return this.nonFixedColumns.reduce(function (sum, item) {
        return sum + _this3.getColumn(item).getWidth();
      }, 0);
    }
  }, {
    key: "getFixedRightWidth",
    value: function getFixedRightWidth() {
      var _this4 = this;

      return this.fixedRightColumns.reduce(function (sum, item) {
        return sum + _this4.getColumn(item).getWidth();
      }, 0);
    }
  }, {
    key: "ignoreFixed",
    value: function ignoreFixed() {
      var tableWidth = this.getTableWidth();
      var fixedWidth = this.getFixedLeftWidth() + this.getFixedRightWidth();
      var nonFixedWidth = this.getNonFixedWidth();
      return fixedWidth + nonFixedWidth <= tableWidth || fixedWidth > tableWidth - this.minimalNonFixedWidth;
    }
  }, {
    key: "ignoreFixedLeft",
    value: function ignoreFixedLeft() {
      return this.ignoreFixed() || this.getFixedLeftWidth() === 0;
    }
  }, {
    key: "ignoreFixedRight",
    value: function ignoreFixedRight() {
      return this.ignoreFixed() || this.getFixedRightWidth() === 0;
    }
  }, {
    key: "isFixedLeftCover",
    value: function isFixedLeftCover() {
      return !this.ignoreFixedLeft() && this.nonFixedScroll !== 0;
    }
  }, {
    key: "isFixedRightCover",
    value: function isFixedRightCover() {
      return !this.ignoreFixedRight() && this.getScrollerWidth() - Math.abs(this.nonFixedScroll) > this.getVisibleWidth();
    }
  }, {
    key: "updateColumnSize",
    value: function updateColumnSize() {
      var _this5 = this;

      var shownColumns = this.getShownColumns();
      var width = this.width;
      var allColumnsMap = {};
      var autoColumns = [];
      var miniWidth = shownColumns.reduce(function (sum, key) {
        var column = _this5.map[key];

        if (!column.getFixedType() && !column.isWidthFixed()) {
          autoColumns.push(column.getKey());
        }

        return sum + (allColumnsMap[column.getKey()] = column.getExpectWidth());
      }, 0);

      if (miniWidth <= width) {
        var left = width - miniWidth;
        var effectColumns = autoColumns.length ? autoColumns : shownColumns;
        var len = effectColumns.length;
        var delta = Math.floor(left / len);
        effectColumns.forEach(function (item, i) {
          allColumnsMap[item] += delta;

          if (i === len - 1) {
            allColumnsMap[item] += left - delta * len;
          }
        });
      }

      shownColumns.forEach(function (key) {
        _this5.map[key].setWidth(allColumnsMap[key]);
      });
    }
  }, {
    key: "updateColumns",
    value: function updateColumns(columns) {
      var map = {};
      var oldLeft = this.fixedLeftColumns;
      var oldNonFixed = this.nonFixedColumns;
      var oldRight = this.fixedRightColumns;
      var fixedLeftColumns = [];
      var nonFixedColumns = [];
      var fixedRightColumns = [];
      columns.forEach(function (item) {
        var key = item.getKey();

        if (map[key]) {
          throw new Error('duplicate column key = ' + key);
        }

        map[key] = item;

        if (!item.isActualShow()) {
          return;
        }

        var type = item.getFixedType();

        if (type === 'left') {
          fixedLeftColumns.push(item.getKey());
          return;
        }

        if (type === 'right') {
          fixedRightColumns.push(item.getKey());
          return;
        }

        nonFixedColumns.push(item.getKey());
      });

      if (nonFixedColumns.length === 0) {
        nonFixedColumns = fixedRightColumns;
        fixedRightColumns = [];
      }

      if (nonFixedColumns.length === 0) {
        nonFixedColumns = fixedLeftColumns;
        fixedLeftColumns = [];
      }

      if (!shallowEqual(oldLeft, fixedLeftColumns)) {
        this.fixedLeftColumns = fixedLeftColumns;
      }

      if (!shallowEqual(oldNonFixed, nonFixedColumns)) {
        this.nonFixedColumns = nonFixedColumns;
      }

      if (!shallowEqual(oldRight, fixedRightColumns)) {
        this.fixedRightColumns = fixedRightColumns;
      }

      this.map = map;
      this.updateColumnSize();
    }
  }]);

  return LeafColumnManager;
}(Emitter);